<template>
  <div id="index">
    <!--孵化在线-->
    <div class="incubation_online">
      <img src="../assets/images/index/incubationOnline.png" alt="">
      孵化在线
      <ul class="incubation_link">
        <a :href="item.link" target="_blank" v-for="item in onlineList" :key="item.id">
          <li>{{item.name}}</li>
        </a>
      </ul>
    </div>
    <header-nav></header-nav>
    <!--轮播图-->
    <div class="carousel wow fadeInUp" data-wow-delay=".5s" >
      <swiper :options="bannerSwiperOption" :not-next-tick="notNextTick" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="item in bannerList" :key="item.id">
          <!--<p class="banner_title">{{item.title}}</p>-->
          <div id="swiper_img"
               v-bind:style="{'background': 'url('+item.link+')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover' }">
          </div>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination" v-if="showBannerController"></div>
        <div class="swiper-button-prev" slot="button-prev" v-if="showBannerController"></div>
        <div class="swiper-button-next" slot="button-next" v-if="showBannerController"></div>
      </swiper>
    </div>
    <!--新闻-->
    <div class="news">
      <!--左-->
      <div class="news_left wow flipInX ">
        <div class="work" 
          :class="curTitleId === item.id ?'active_news':'default_news'" v-for="item in newsTitle"
          @click="getNews(item.id)" 
          :key="item.id">
          <p>{{item.cnTitle}} </p>
          <p>{{item.enTitle}}</p>
          <!--三角形-->
          <span class="triangle">
            <span></span>
          </span>
        </div>
      </div>
      <!--右-->
      <!--根据id显示不同数据-->
      <news-list :news-data="newsData" :cur-plate-id="curTitleId" class="wow bounceInRight" data-wow-delay=".5s"></news-list>
    </div>
    <!--政策法规  孵化服务-->
    <div class="policies_and_service">
      <div class="policies_service_title wow flipInX" data-wow-delay=".5s">
        <div class="policies_title">
          <img class="title_img" src="../assets/images/index/titleMark.png" alt="">
          <p> 政策法规 <span>Policies and regulations</span></p>
        </div>
        <div class="service_title">
          <img class="title_img" src="../assets/images/index/titleMark.png" alt="">
          <p> 孵化服务<span>Incubation service</span></p>
        </div>
      </div>
    </div>
    <div class="policies_service_content">
      <div class="policies_content wow bounceInLeft" data-wow-delay=".5s">
        <!--18-->
        <index-list :plate-data="policiesArticleList" :menu-id="18"></index-list>
      </div>
      <div class="service_content wow bounceInRight" data-wow-delay=".5s">
        <!--21-->
        <index-list :plate-data="serviceArticleList" :menu-id="21"></index-list>
      </div>
    </div>
    <!--园区风采-->
    <div class="park_style">
      <div class="park_title">
        <img class="title_img" src="../assets/images/index/titleMark.png" alt="">
        <p> 园区风采 <span>Park style</span></p>
      </div>
    </div>
    <div class="park_style_content">
      <div class="park_play wow pulse" data-wow-delay=".5s">
        <video :src="videoUrl" controls="controls"></video>
        <!-- <img class="play_img" src="../assets/images/index/play.png" alt="" @click="parkStylePlay()">-->
      </div>
      <div class="park_play_swiper wow" data-wow-delay=".5s">
        <park-style :park-style-swiper-list="parkStyleSwiperList"></park-style>
      </div>
    </div>
    <!--入园申请-->
    <div class="park_apply">
      <div class="park_apply_content">
        <div class="contact wow rollIn" data-wow-delay=".5s">
          <p class="contact_title">联系方式</p>
          <ul>
            <li><p>地址 : <span>{{contact.address}}</span></p></li>
            <li>
              <!--<p>联系人 : <span> {{contact.linkman}}</span></p>-->
              <p>联系电话 : <span> {{contact.phone}}</span></p>
            </li>
            <li>
              <p>邮件 : <span> {{contact.email}}</span></p>
            </li>
            <div class="qrcode_li">
              <!--<p>二维码 </p>-->
              <!--<div class="qrcode_img"  v-bind:style="{'background': 'url('+contact.qrCode+')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover' }"></div>-->
              <img :src="contact.qrCode" class="qrcode_img" alt="qrCode">
            </div>
          </ul>
        </div>
        <div class="apply_form wow lightSpeedIn" data-wow-delay=".5s">
          <p class="apply_title"><span>入园申请</span></p>
          <apply-form></apply-form>
        </div>
      </div>
    </div>
    <!--合作伙伴-->
    <partner-list></partner-list>
    <!--底部-->
    <common-footer></common-footer>
  </div>
</template>

<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import CommonFooter from '@/components/CommonFooter.vue'
  import IndexList from '@/components/IndexList.vue'
  import PartnerList from '@/components/PartnerList.vue'
  import NewsList from '@/components/NewsList.vue'
  import ParkStyle from '@/components/ParkStyle.vue'
  import ApplyForm from '@/components/ApplyForm.vue'
  import {swiper, swiperSlide} from 'vue-awesome-swiper';
  import 'swiper/dist/css/swiper.css'
  import bannerImg from '../assets/images/index/banner.png'
  import newsSwiper from '../assets/images/index/newsSwiper.png'
  import parkSwiper0 from '../assets/images/index/parkStyleSwiper.png'
  import parkSwiper1 from '../assets/images/index/parkStyleSwiper1.png'
  import {queryBanner} from '@/api/Banner.js'
  import {queryArticleList} from '@/api/ArticleList.js'
  import {queryContact} from '@/api/Contact.js'
  import {queryOnline} from '@/api/IncubationOnline.js'
  import {queryParkStyle} from '@/api/ParkStyle.js'
  import {WOW} from 'wowjs'

  export default {
    name: 'Index',
    components: {
      CommonFooter,
      HeaderNav,
      IndexList,
      PartnerList,
      NewsList,
      ApplyForm,
      swiper,
      swiperSlide,
      ParkStyle
    },
    data() {
      return {
        //孵化在线
        onlineList: [],
        bannerList: [],
        notNextTick: false,
        bannerSwiperOption: {
          autoplay: 4000,
          direction: 'horizontal',
          grabCursor: true,
          setWrapperSize: true,
          autoHeight: true,
          pagination: '.swiper-pagination',
          paginationClickable: true,
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next',
          //scrollbar: '.swiper-scrollbar',
          mousewheelControl: false,
          observer: true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents: false,
          /*onSlideChangeEnd: function (swiper) {
            swiper.update();
            swiper.startAutoplay();
            swiper.reLoop();
          }*/
        },
        showBannerController: true,
        //新闻
        newsTitle: [
          {
            id: 22,
            menuId: 29,
            cnTitle: '工作动态',
            enTitle: 'WORK DYNAMICS'
          }, {
            id: 23,
            menuId: 29,
            cnTitle: '公示公告',
            enTitle: 'PUBLIC ANNOUNCEMENT'
          },
        ],
        curTitleId: 22,
        newsData: [],//传到子组件
        //政策法规  孵化服务 文章列表数据
        policiesArticleList: [
          {
            id: 10,
            plateName: '最新政策',
            children: []
          }, {
            id: 11,
            plateName: '地方政策',
            children: []
          },
        ],
        serviceArticleList: [
          {
            id: 14,
            plateName: "创业导师",
          }, {
            id: 13,
            plateName: "知识产权",
          }, {
            id: 16,
            plateName: "科技金融",
          },{
            id: 18,
            plateName: "会计法务",
          }, {
            id: 19,
            plateName: "人力资源",
          }
        ],
        //园区风采
        videoUrl: '',
        showParkStyleController: true,
        parkStyleSwiperList: [],
        //联系方式
        contact: {},
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      },
    },
    created() {
      
    },
    mounted() {
      
      if (window.location.host == 'www.mmgxcyfh.com') {
        this.getBanner()
        this.getContact()
        this.getOnline()
        this.getNews()
        this.getImg()
        this.getVideo()
      }
      new WOW().init()
    },
    methods: {
      //孵化在线
      getOnline() {
        queryOnline().then((res) => {
          this.onlineList = res
        })
      },
      //轮播图
      getBanner() {
        queryBanner().then((res) => {
          this.bannerList = res
          if (this.bannerList.length <= 1) {
            this.showBannerController = false
          } else {
            this.showBannerController = true
          }
        })
      },
      //园区风采
      getImg() {
        queryParkStyle(0).then((res) => {
          this.parkStyleSwiperList = res.filter((item) => {
            return item.homePage === 0
          })
          if (this.parkStyleSwiperList.length > 4) {
            this.showParkStyleController = true
          } else {
            this.showParkStyleController = false
          }
        })
      },
      //视频
      getVideo() {
        queryParkStyle(1).then((res) => {
          let videoUrl = res.filter((item) => {
            return item.homePage == 0
          })
          this.videoUrl = videoUrl[0].url
        })
      },
      parkStylePlay() {

      },
      //新闻
      getNews(id) {
        id == undefined ? this.curTitleId : this.curTitleId = id
        queryArticleList(29, this.curTitleId, 0, 9).then((res) => {
          this.newsData = res.list
          //console.log(this.newsData)
        })
      },
      //联系方式
      getContact() {
        queryContact().then((res) => {
          this.contact = res
        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  /*覆盖swiper样式*/
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right: 90px;
    background-image: url("../assets/images/index/next.png")
  }

  .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: 90px;
    background-image: url("../assets/images/index/pre.png")
  }

  .swiper-button-prev, .swiper-button-next {
    width: 55px;
    height: 55px;
    background-size: 55px 55px;
  }

  .park_play_swiper .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    background-image: url("../assets/images/index/swiperNext.png");
    /* width: 24px;
     height: 39px;*/
    right: 20px;
  }

  .park_play_swiper .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    width: 24px;
    height: 39px;
    background-image: url("../assets/images/index/swiperPre.png");
    left: 20px;
  }

  .park_play_swiper .swiper-button-prev, .park_play_swiper .swiper-button-next {
    width: 24px;
    height: 39px;
    background-size: 24px 39px;
  }

  //$themeColor: #3e76fc;
  #index {
    overflow-x: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #fff;
    position: relative;
    /*孵化在线---开始*/
    .incubation_online {
      width: 86px;
      height: 86px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      font-size: 14px;
      color: #fff;
      position: fixed;
      top: 50%;
      right: 10px;
      background-color: $themeColor;
      z-index: 7;
      cursor: pointer;
      img {
        width: 39px;
        height: 40px;
      }
    }
    .incubation_online:hover {
      background-color: #656871;
      .incubation_link {
        display: block;
      }
    }
    .incubation_link li:hover {
      background-color: $themeColor;
      color: #fff;
    }
    .incubation_link {
      display: none;
      position: absolute;
      top: 96%;
      right: 0px;
      margin-top: 3px;
      overflow: hidden;
      border: 1px solid #dedede;
      border-radius: 5px;
      box-shadow: 3px 3px 10px 1px #ccc;
      z-index: 7;
      background-color: #fff;
      a li {
        min-width: 200px;
        line-height: 40px;
        font-size: 14px;
        color: #333;
        padding: 0 15px;
        border-bottom: 1px dashed #dedede;
      }
    }
    a li:nth-last-child(1) {
      border-bottom: none
    }
    /*孵化在线---结束*/
    /*轮播*/
    .carousel {
      width: 1200px;
      height: 480px;
      margin-top: 20px;
      position: relative;
      #swiper_img {
        width: 1200px;
        height: 480px;
      }
      .banner_title {
        width: 800px;
        line-height: 60px;
        color: #fff;
        font-size: 52px;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -400px;
        margin-top: -30px;
      }
    }
    //新闻
    .news {
      width: 1200px;
      height: 340px;
      min-width: 1200px;
      margin-top: 98px;
      display: flex;
      //左
      .news_left {
        .work {
          width: 250px;
          height: 168px;
          background-color: #656871;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          cursor: pointer;
          P {
            font-size: 24px;
            color: #fff;
          }
          p:last-of-type {
            margin-top: 12px;
            font-size: 12px;
          }
          .triangle {
            width: 0;
            height: 0;
            border-width: 12px 0 12px 20px;
            border-style: solid;
            border-color: transparent transparent transparent #656871;
            margin: 40px auto;
            position: absolute;
            top: 21%;
            left: 100%;
            z-index: -1;
          }
        }
        .work:last-of-type {
          margin-top: 4px;
        }
        .default_news {
          background-color: #656871;
          .triangle {
            border-color: transparent transparent transparent #656871;
          }
        }
        //激活样式
        .active_news {
          background-color: $themeColor;
          .triangle {
            z-index: 6;
            border-color: transparent transparent transparent $themeColor;
          }
        }
      }
    }
    //政策法规  孵化服务
    .policies_and_service {
      width: 100%;
      height: 64px;
      border-bottom: 1px solid #ccc;
      margin-top: 80px;
      margin-bottom: 50px;
      display: flex;
      justify-content: center;
      .policies_service_title {
        width: 1200px;
        display: flex;
        .policies_title, .service_title {
          display: flex;
          align-items: center;
          img {
            width: 34px;
            height: 30px;
          }
          p {
            font-size: 28px;
            margin-left: 20px;
            color: #3c3c3c;
            span {
              font-size: 16px;
              margin-left: 10px;
              color: #999;
            }
          }
        }
        .policies_title {
          width: 490px;
          height: 64px;
          margin-right: 40px;
        }
        .service_title {
          width: 670px;
          height: 64px;
        }
      }
    }
    .policies_service_content {
      width: 1200px;
      display: flex;
      .policies_content, .service_content {
        position: relative;
        height: 450px;
        border: 1px solid #dadada;
        border-radius: 3px;
      }
      .policies_content {
        width: 490px;
        margin-right: 40px;
      }
      .service_content {
        width: 670px;
      }
    }
    .park_style {
      width: 1200px;
      margin-top: 120px;
      /*margin-bottom: 20px;*/
      .park_title {
        height: 64px;
        display: flex;
        align-items: center;
        .title_img {
          width: 34px;
          height: 30px;
        }
        p {
          font-size: 28px;
          margin-left: 20px;
          color: #3c3c3c;
          span {
            font-size: 16px;
            margin-left: 10px;
            color: #999;
          }
        }
      }
    }
    .park_style_content {
      width: 100%;
      height: 1024px;
      background: url("../assets/images/index/parkStyleBg1.png") no-repeat center center;
      position: relative;
      display: flex;
      justify-content: center;
      .park_play {
        width: 890px;
        height: 520px;
        position: absolute;
        top: 8%;
        left: 50%;
        margin-left: -445px;
        video {
          width: 100%;
          height: 100%;
        }
        .play_img {
          width: 104px;
          height: 104px;
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -52px;
          margin-top: -52px;
          cursor: pointer;
        }
      }
      .park_play_swiper {
        width: 1200px;
        height: 268px;
        margin-top: 710px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        position: relative;
        

      }
    }
    //入园申请
    .park_apply {
      width: 100%;
      height: 562px;
      margin: 80px 0 80px 0;
      background: url("../assets/images/index/applyBg2.png") no-repeat center center;
      display: flex;
      justify-content: center;
      align-items: center;
      .park_apply_content {
        width: 1200px;
        height: 452px;
        display: flex;
        .contact {
          width: 372px;
          height: 100%;
          margin-right: 44px;
          padding: 20px 10px 0 30px;
          background: url("../assets/images/index/contactBg.png") no-repeat center center;
          background-color: #fff;
          .contact_title {
            font-size: 18px;
            color: $themeColor;
          }
          ul {
            font-size: 16px;
            li {
              /*min-height: 70px;*/
              height: 70px;
              border-bottom: 1px solid #e5e5e5;
              color: #333;
              display: flex;
              flex-direction: column;
              justify-content: center;
              span {
                color: #999;
              }
              p {
                line-height: 30px;
              }
            }
            .qrcode_li {
              border-bottom: none;
              /*height: 200px;*/
              display: flex;
              /*flex-direction: column;*/
              justify-content: flex-start;
              align-items: center;
              /*position: relative;*/
              /* p{
                !*margin-top: 10px;*!
                 position: absolute;
                 top: 10px;
                 left:0;
               }*/
              .qrcode_img {
                width: 140px;
                height: 140px;
                margin-top: 30px;
                margin-left: 86px;
              }
            }
          }
        }
        .apply_form {
          width: 784px;
          height: 100%;
          padding: 0 10px;
          background-color: #fff;
          position: relative;
          .apply_title {
            height: 60px;
            font-size: 18px;
            color: $themeColor;
            border-bottom: 1px solid #e5e5e5;
            span {
              margin-left: 30px;
              line-height: 60px;
            }
          }

        }
      }
    }
  }
</style>
